import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgClockMostOfTheTimeGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M29.064 12.2V8h-9.715v4.279c-.82.306-1.601.692-2.342 1.137-.366.217-.712.444-1.058.691a14.415 14.415 0 0 0-3.478 3.578c-.238.346-.455.712-.662 1.087-.9 1.62-1.493 3.43-1.71 5.347-.06.514-.099 1.037-.099 1.57v.09C10.05 33.596 16.404 39.95 24.221 40h.089c.534 0 1.058-.03 1.571-.089a14.151 14.151 0 0 0 5.357-1.71c.375-.207.731-.425 1.087-.662a14.588 14.588 0 0 0 3.577-3.479c.247-.336.475-.691.692-1.057a14.053 14.053 0 0 0 1.858-5.198c.08-.524.129-1.058.148-1.601.01-.178.03-.346.03-.524 0-6.226-4.003-11.523-9.566-13.48Zm-8.48-2.965h7.244v2.59a14.226 14.226 0 0 0-3.508-.455c-.178 0-.356.01-.534.02-.543.02-1.067.069-1.59.158-.544.089-1.088.197-1.612.336V9.235Zm-9.27 17.848 11.603 11.603c-6.098-.653-10.96-5.505-11.603-11.603Zm13.411 11.662-13.47-13.47c.06-2.016.573-3.914 1.453-5.604l17.61 17.611a13.02 13.02 0 0 1-5.593 1.463Zm6.7-2.105L13.35 18.564a13.173 13.173 0 0 1 3.469-3.587l18.194 18.194a12.894 12.894 0 0 1-3.587 3.469Zm4.27-4.536L17.886 14.305a13.09 13.09 0 0 1 5.416-1.65l14.043 14.043a13.093 13.093 0 0 1-1.65 5.406Zm-10.663-19.46c6.63.367 11.957 5.683 12.323 12.324L25.032 12.645Z",
    fill: "currentColor"
  }));
}

export { SvgClockMostOfTheTimeGlyph as default };
